
import Page from '@/Page.vue';
import { Component, Watch } from 'vue-property-decorator';
import { locationsStore } from '@/libs/locations/+state/store';
import { LocationModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import LocationShifts from '@/libs/shifts/components/LocationShifts.vue';

@Component({
    components: { LocationShifts },
})
export default class ShiftWork extends Page {
    locationId: string | null = null;

    @Watch('locationId')
    locationIdChanged(v: string | null) {
        this.setQuery('location', v, true);
    }

    created() {
        if (this.getQuery('location', true)) {
            this.locationId = this.getQuery('location', true);
        }
    }

    get locations(): LocationModel[] {
        const locations = locationsStore.useGetter(CrudGetter.Data) as LocationModel[];
        return locations.filter((x) => x.canPlanShifts);
    }
}
